import { useState } from "react";
import { faqs } from "@/mocks/site";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-14">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">FAQ</p>
          <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            关于内容更新、观看方式、投稿与版权，这里都有答案。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-xl bg-background-50 ring-1 ring-inset transition ${
                  isOpen ? "ring-primary-300" : "ring-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <h3 className="text-sm font-semibold text-foreground-900 md:text-base">{item.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                      isOpen ? "rotate-180 bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" />
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-6 text-foreground-600">{item.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}